import React from 'react';
import {useDropzone} from 'react-dropzone';

const Basic = () => {
  const {acceptedFiles, getRootProps, getInputProps} = useDropzone();

  const files = acceptedFiles.map((file: any) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <section className='container'>
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()} />
        <p>Drag n drop some files here, or click to select files</p>
      </div>
      <aside>
        <h6>Files</h6>
        <ul>{files}</ul>
      </aside>
    </section>
  );
};

export default Basic;
